/* V2-PAGES 04/11/2026, chantier C (blog r36s-console.com) : petites finitions de l'article, aucune modification de texte.
   1. Carte d'achat : la console affichée suit le coloris choisi.
   2. Sommaire ordinateur : lien de la partie lue en surbrillance.
   3. Tableaux larges : défilement horizontal dans leur carte au lieu de pousser la page.
   4. Images cassées du corps d'article (anciens encadrés) : masquées au lieu d'afficher leur texte alternatif ; encadrés vides masqués. */
(function () {
  function pickColors() {
    var img = document.querySelector('[data-r36pg-col]');
    if (!img) return;
    var cols; try { cols = JSON.parse(img.getAttribute('data-cols') || '[]'); } catch (e) { return; }
    var box = img.closest('[data-r36s-buy]');
    if (!box) return;
    box.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.name !== 'r36s-o1') return;
      var i = parseInt(t.getAttribute('data-ci'), 10);
      if (isNaN(i) || !cols[i]) return;
      img.src = cols[i];
    });
  }
  function wrapTables() {
    var c = document.getElementById('articleContent');
    if (!c) return;
    c.querySelectorAll('table').forEach(function (t) {
      if (t.closest('.r36pg-tw') || t.closest('[data-blog-cta]')) return;
      var w = document.createElement('div'); w.className = 'r36pg-tw';
      t.parentNode.insertBefore(w, t); w.appendChild(t);
    });
  }
  function hideBroken() {
    var c = document.getElementById('articleContent');
    if (!c) return;
    c.querySelectorAll('img').forEach(function (im) {
      if (im.closest('[data-blog-cta]')) return;
      var kill = function () {
        im.style.display = 'none';
        /* l'encadré qui ne contenait que cette image devient vide : on le masque aussi (2 niveaux max, jamais le corps) */
        var p = im.parentElement;
        for (var k = 0; k < 3 && p && p !== c; k++) {
          var vis = [].some.call(p.querySelectorAll('img'), function (x) { return x.style.display !== 'none'; });
          if (p.textContent.replace(/\s+/g, '') !== '' || vis) break;
          p.style.display = 'none'; p = p.parentElement;
        }
      };
      if (im.complete && im.naturalWidth === 0 && (im.currentSrc || im.src)) kill();
      else im.addEventListener('error', kill, { once: true });
    });
  }
  function hideEmpty() {
    /* encadrés vides laissés dans certains articles (blockquote sans texte) : plus de carte vide à l'écran */
    var c = document.getElementById('articleContent');
    if (!c) return;
    c.querySelectorAll('blockquote').forEach(function (b) {
      if (b.textContent.replace(/\s+/g, '') === '' && !b.querySelector('img,iframe,video')) b.style.display = 'none';
    });
  }
  function tocSpy() {
    var toc = document.getElementById('articleToc');
    if (!toc) return;
    var list = toc.querySelector('.article-toc__list');
    var links = toc.querySelectorAll('.article-toc__list a');
    if (!list || !links.length) return;
    var items = [];
    function collect() { /* les id heading-N sont posés au DOMContentLoaded : relevé au premier défilement */
      items = [];
      links.forEach(function (a) { var h = document.getElementById((a.getAttribute('href') || '').slice(1)); if (h) items.push({ a: a, h: h }); });
    }
    var on = null, tick = false;
    function update() {
      tick = false;
      if (!list.offsetParent) return; /* sommaire replié (mobile) : rien à faire */
      if (!items.length) collect();
      var cur = null;
      for (var i = 0; i < items.length; i++) { if (items[i].h.getBoundingClientRect().top < 220) cur = items[i]; else break; }
      var a = cur ? cur.a : null;
      if (a === on) return;
      if (on) on.classList.remove('is-on');
      on = a;
      if (a) {
        a.classList.add('is-on');
        var tr = toc.getBoundingClientRect(), r = a.getBoundingClientRect();
        if (r.top < tr.top + 50 || r.bottom > tr.bottom - 16) toc.scrollTop += r.top - tr.top - tr.height / 2;
      }
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
  function init() { pickColors(); wrapTables(); hideBroken(); hideEmpty(); setTimeout(tocSpy, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
